import { LogoOutline } from '@/components/LogoOutline';
import { Stack } from '@mui/material';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useAuthStyles: any = makeStyles((theme: any) => ({
  root: {
    minHeight: '100vh',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EEF6FA',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex'
  },
  logo: {
    zIndex: 0,
    position: 'absolute',
    bottom: '-6em',
    left: '-6em',
    height: '35em',
    width: '35em'
  },
  content: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.spacing(1.5),
    zIndex: 2,
    position: 'absolute',
    top: '18vh'
  },
  contentOuterStack: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.spacing(1.5)
  },
  contentInnerStack: {
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  logoContainer: {
    display: 'flex',
    height: 110,
    flexDirection: 'column'
  },
  contentLogo: {
    width: '182px',
    alignSelf: 'center'
  },
  header: {
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: '32px'
  },
  user: {
    color: '#999999',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px'
  },
  message: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px'
  },
  field: {
    '& input:-webkit-autofill': {
      '-webkit-box-shadow': '0 0 0 30px white inset !important',
      '-webkit-text-fill-color': '#000 !important'
    },
    '& input:-webkit-autofill:hover': {
      '-webkit-box-shadow': '0 0 0 30px white inset !important',
      '-webkit-text-fill-color': '#000 !important'
    },
    '& input:-webkit-autofill:focus': {
      '-webkit-box-shadow': '0 0 0 30px white inset !important',
      '-webkit-text-fill-color': '#000 !important'
    },
    '& input:-webkit-autofill:active': {
      '-webkit-box-shadow': '0 0 0 30px white inset !important',
      '-webkit-text-fill-color': '#000 !important'
    }
  },
  submit: {
    fontSize: '14px',
    fontWeight: 600,
    backgroundColor: theme.palette.primary.restoreBlue,
    '&:hover': {
      backgroundColor: theme.palette.primary.quiet
    }
  },
  extra: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '10px',
    color: theme.palette.primary.restoreBlue,
    '&:hover': {
      color: theme.palette.primary.quiet,
      backgroundColor: 'transparent'
    }
  }
}));

type AuthLayoutProps = {
  children: React.ReactNode;
  extended?: boolean;
};

export const AuthLayout = ({ children, extended = false }: AuthLayoutProps) => {
  const classes = useAuthStyles();

  return (
    <Box className={classes.root}>
      <Stack
        className={classes.content}
        sx={{ maxWidth: extended ? '360px' : '280px' }}
      >
        {children}
      </Stack>
      <Box className={classes.logo}>
        <LogoOutline />
      </Box>
    </Box>
  );
};
export default AuthLayout;
